/**
 * Authentication utility functions
 */

// Token management
export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

// User data management
export const setUserData = (userData) => {
  localStorage.setItem('userData', JSON.stringify(userData));
};

export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

export const removeUserData = () => {
  localStorage.removeItem('userData');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const setCompanyData = (companyData) => {
  localStorage.setItem('userCompany', companyData)
}

export const getCompanyData = () => {
  const userCompany = localStorage.getItem('userCompany');
  return userCompany ? JSON.parse(userCompany) : null;
}

// Logout helper
export const logout = () => {
  removeAuthToken();
  removeUserData();
  // Clear any other auth-related data here
};

export default {
  setAuthToken,
  getAuthToken,
  removeAuthToken,
  setUserData,
  getUserData,
  removeUserData,
  isAuthenticated,
  logout
};
